import { handleReactQuillDeltaValue } from '../../../functions/handleReactQuillDeltaValue';

export function checkQuillEditorDeltaIsEmpty(value: unknown) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let preparedValue: any = value;

  if (typeof value === 'string') {
    preparedValue = handleReactQuillDeltaValue(value);
  }

  let symbolCount = 0;

  if (typeof preparedValue === 'object' && preparedValue?.ops) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    preparedValue.ops.forEach((op: any) => {
      symbolCount +=
        typeof op.insert === 'string' ? op.insert?.replaceAll('\n', '')?.replaceAll('\t', '')?.trim()?.length || 0 : 0;
    });
  }

  return symbolCount === 0;
}

export function makeRequiredQuillEditorDelta(errorMsg: string, getException?: () => boolean) {
  return (value: unknown) => {
    const isException = getException && getException();

    if (isException) {
      return undefined;
    }

    return !value || (typeof value === 'object' && checkQuillEditorDeltaIsEmpty(value)) ? errorMsg : undefined;
  };
}
